import React from "react";
import { Flex } from "@chakra-ui/react";
import { FluidBolus, DefibMedications, Medications } from "../../../shared";

const Emergency: React.FC = () => {
  return (
    <Flex direction="column" rowGap={12}>
      <Medications />
      <DefibMedications />
      <FluidBolus />
    </Flex>
  );
};

export default Emergency;
